import { AxiosError } from 'axios';
import { usePushdownContext } from '../../../../../../../../providers/Pushdown/PushdownProvider';
import {
    ISubmitResponseError,
    EPrequalDecisionResult as result,
} from '../../../../../../../../types/shared/PrequalificationDataEntry';
import {
    clearSessionStorageVariablesForAcquisitionFlow,
    getDataEntryPages,
    getQueryParams,
} from '../../../../../../../../utils/acquisition-utils';
import { usePageProperties } from '../../../../../../providers/PagePropertiesProvider';
import { useLoader } from '../../../../../../providers/LoaderProvider';
import { MutableRefObject } from 'react';

export default function useHandleError() {
    const { errorTitle: header, errorDesc } = usePageProperties();
    const { showPushdown } = usePushdownContext();
    const { setShouldRenderLoader } = useLoader();

    const handleApiErrorResponse = (
        errors: ISubmitResponseError[],
        customErrorMessage: string,
    ) => {
        if (errors.length === 0 && !customErrorMessage) {
            showPushdown('processingError');
        } else if (errors.length > 0 && !customErrorMessage) {
            const message = errors.map(({ ErrorMessage }) => ErrorMessage);

            showPushdown({
                color: 'error',
                header,
                description: errorDesc,
                message,
            });
        } else if (customErrorMessage) {
            showPushdown({
                color: 'error',
                header,
                description: customErrorMessage,
            });
        }
    };

    /**
     * the destructuring comes from the way axios handles error responses (400+)
     */
    const handleSubmitError =
        (submittingStateRef: MutableRefObject<boolean>) => (error: unknown) => {
            setShouldRenderLoader(false);
            submittingStateRef.current = false;

            const { response } = error as AxiosError;

            if (!response) {
                handleApiErrorResponse(
                    [],
                    'Something went wrong on the server. Please review the form and try again later.',
                );
            }

            const { data, status } = response as any;
            if (data?.PrequalDecisionResult === result.ERROR) {
                handleApiErrorResponse(data.Errors ?? [], '');
            } else if ([401, 408].includes(status)) {
                clearSessionStorageVariablesForAcquisitionFlow();
                const baseRedirectUrl =
                        getDataEntryPages().preQualDataEntryPageUrl;
                const params = new URLSearchParams(window.location.search);
                params.set('errorCode', 'lost');
                window.location.assign(
                    baseRedirectUrl + '?' + params.toString(),
                );
            } else {
                // API services are down or any other scenario stay on PQDE with processingError
                handleApiErrorResponse([], '');
            }
        };

    return {
        handleSubmitError,
    };
}
